export const PAGE_SIZE = 100;
export const FIRST_PAGE = 1;
export const pageSizeOptions = [50, 100, 150, 200];

